<template>
  <VDialogV3
    id="tehno-shipment-card"
    position="bottom"
    :entity="tehnoShipment ?? undefined"
    :show-submit-button="false"
  >
    <template v-if="tehnoShipment === null">
      Отгрузка ещё не выгружалась в Техно
    </template>

    <template v-else>
      <header class="document-header">
        <dl>
          <dt>Документ поставщика</dt>
          <dd>
            {{ tehnoShipment.documentType }} №{{ tehnoShipment.documentNumber }}
            от {{ tehnoShipment.documentDate.format() }}
          </dd>
          <dt>Дата отгрузки</dt>
          <dd>{{ tehnoShipment.shipmentDate.format() }}</dd>
        </dl>

        <dl>
          <dt>Техно</dt>
          <dd>{{ tehnoShipment.externalNumber !== null ? `№${tehnoShipment.externalNumber}` : 'Номер ещё не получен' }}</dd>
          <dt>Реализация</dt>
          <dd>
            <template v-if="tehnoShipment.shipmentToBuyerId !== null">
              СФТ №{{ tehnoShipment.shipmentToBuyerId }} от {{ tehnoShipment.shipmentToBuyerDate?.format() }}
            </template>
            <template v-else>--</template>
          </dd>
        </dl>

        <aside class="totals">
          <section>
            <header>В валюте учёта</header>
            <dl>
              <dt class="total">Итого в Техно</dt>
              <dd class="total">{{ tehnoShipment.tehnoSumFull?.format(tehnoShipment.accountingCurrencyCode) || '---' }}</dd>
              <dt>Документ поставщика</dt>
              <dd>{{ tehnoShipment.accountingSumFull?.format(tehnoShipment.accountingCurrencyCode) || '---' }}</dd>
              <dt>Дооценка</dt>
              <dd>{{ tehnoShipment.accountingServiceSumFull.format(tehnoShipment.accountingCurrencyCode) }}</dd>
            </dl>
          </section>
        </aside>
      </header>

      <VDataGridV2
        :data="tehnoShipment.livePositions"
        layout="fill"
      >
        <VDataGridColumnV2
          id="name"
          content-align="left"
          content-class="ellipsis"
          width="400px"
        >
          <template #label>
            <div>Товар</div>
            <div class="description">№ позиции заказа</div>
          </template>
          <template #default="{ row }">
            {{ row.name }}
            <div class="description">{{ $core.utils.string.formatWithDelimiter(row.orderPositionId) }}</div>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="qty"
          content-align="right"
          width="140px"
        >
          <template #label>
            <div>Кол-во</div>
            <div class="description">В базовых единицах</div>
          </template>
          <template #default="{ row }">
            {{ row.qty.format() }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="price"
          content-align="right"
          width="200px"
          label="Цена в Техно"
        >
          <template #default="{ row }">
            {{ row.accountingPriceFull?.formatSmart() || '---' }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="sum-supplier"
          content-align="right"
          width="170px"
          label="Сумма поставщика"
        >
          <template #default="{ row }">
            {{ row.accountingSumFull?.format(row.accountingCurrencyCode) || '---' }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="service-share"
          content-align="right"
          width="170px"
          label="Дооценка"
        >
          <template #default="{ row }">
            {{ row.accountingServiceSumFull.format(row.accountingCurrencyCode) }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="sum-tehno"
          content-align="right"
          width="170px"
          label="Сумма в Техно"
        >
          <template #default="{ row }">
            {{ row.tehnoSumFull?.format(row.accountingCurrencyCode) || '---' }}
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </template>
  </VDialogV3>
</template>

<script lang="ts">
import TehnoShipmentsService from '@/domains/Shipments/TehnoShipmentsService';
import type TehnoShipment    from '@/domains/Shipments/TehnoShipment';

export default defineComponent({
  name: 'TehnoShipmentCard',

  props: {
    shipmentId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      tehnoShipment: null as TehnoShipment | null,
    };
  },

  async created() {
    this.tehnoShipment = await TehnoShipmentsService.getByShipmentId(this.shipmentId);
  },
});
</script>
